<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>促销</el-breadcrumb-item>
      <el-breadcrumb-item>促销历史</el-breadcrumb-item>
    </el-breadcrumb>
    <promotion-list :type="2"></promotion-list>
  </div>
</template>

<script>
import PromotionList from './list'
export default {
  components: { PromotionList },
}
</script>